<template>
    <div>
        <!--Edit-->
        <div class="container" v-if="EditView">
            <div class="page-inner">
                <div class="page-header gp-admin-page-heading">
                    <h3 class="fw-bold">{{ Aviso.admId ? 'Alterar aviso do sistema' : 'Novo aviso do sistema' }}</h3>
                    <ul class="breadcrumbs">
                        <li class="nav-home"> <router-link to="/home"><i class="fa fa-home"></i></router-link> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><a href="#" @click.prevent="EditCancel()">Cadastro de aviso sistema</a> </li>
                        <li class="separator"><i class="fa fa-chevron-right"></i> </li>
                        <li class="nav-item"><span>{{ Aviso.admId ? 'Alterar' : 'Novo cadastro' }}</span></li>
                    </ul>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="gp-admin-form-header">
                                <span><v-icon size="20">mdi-bell-outline</v-icon></span>
                                <div>
                                    <h4>{{ Aviso.admId ? 'Alterar aviso do sistema' : 'Novo aviso do sistema' }}</h4>
                                    <p>Preencha os dados e defina a disponibilidade deste cadastro.</p>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-2 col-lg-2" v-show="false">
                                        <div class="form-group">
                                            <label>Identificador</label>
                                            <input v-model="Aviso.admId" type="text" class="form-control"
                                                placeholder="Id" />
                                        </div>
                                    </div>
                                    <div class="col-md-6 col-lg-6">
                                        <div class="form-group">
                                            <label>Título</label>
                                            <input v-model="Aviso.admTitulo"
                                                type="text" class="form-control" placeholder="Título do aviso" />
                                        </div>
                                    </div>
                                    <div class="col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label>Ativo</label>
                                            <select v-model="Aviso.admAtivo" class="form-select form-control">
                                                <option value="">Selecione</option>
                                                <option :value=true>Sim</option>
                                                <option :value=false>Não</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-md-12 col-lg-12">
                                        <div class="form-group">
                                            <label>Texto</label>
                                            <textarea v-model="Aviso.admTexto" class="form-control" 
                                                placeholder="Texto do aviso" rows="3"></textarea>
                                        </div>
                                    </div>

                                    <div class="col-md-6 col-lg-6">
                                        <div class="form-group">
                                            <label>Texto do Botão</label>
                                            <input v-model="Aviso.admTextoBotao"
                                                type="text" class="form-control" placeholder="Ex: Ver detalhes" />
                                        </div>
                                    </div>

                                    <div class="col-md-6 col-lg-6">
                                        <div class="form-group">
                                            <label>Link do Botão</label>
                                            <input v-model="Aviso.admLinkBotao"
                                                type="text" class="form-control" placeholder="Ex: https://www.seusite.com.br" />
                                        </div>
                                    </div>

                                    <div class="col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label>Visível para Garantidoras</label>
                                            <select v-model="Aviso.admVisivelGarantidora" class="form-select form-control">
                                                <option value="">Selecione</option>
                                                <option :value=true>Sim</option>
                                                <option :value=false>Não</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label>Visível para Imobiliárias</label>
                                            <select v-model="Aviso.admVisivelImobiliaria" class="form-select form-control">
                                                <option value="">Selecione</option>
                                                <option :value=true>Sim</option>
                                                <option :value=false>Não</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div class="col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label>Data Inicial</label>
                                            <input v-model="Aviso.admDataInicial"
                                                type="date" class="form-control" />
                                        </div>
                                    </div>

                                    <div class="col-md-3 col-lg-3">
                                        <div class="form-group">
                                            <label>Data Final (Opcional)</label>
                                            <input v-model="Aviso.admDataFinal"
                                                type="date" class="form-control" />
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-action gp-admin-actions gp-detail-actions">
                        <button v-if="Aviso.admId != 0" type="button" class="btn btn-success"
                            style="color:#ffffff;" @click="Put()">
                            Alterar
                        </button>
                        <button v-else type="button" class="btn btn-success" style="color:#ffffff;" @click="Add()">
                            Salvar
                        </button>
                        <a href="#" @click="EditCancel()"  class="btn btn-link">Cancelar</a>
                    </div>
                </div>
            </div>
        </div>
        <!--Grid-->
        <div class="container" v-if="!EditView">
            <div class="page-inner">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card">
                            <div class="card-header">
                                <div class="d-flex align-items-center">
                                    <h4 class="card-title">Cadastro de avisos do sistema</h4>
                                    <a href="#" @click="EditNew()" class="btn btn-sm btn-secondary ms-auto">
                                        <i class="fa fa-plus"></i>
                                        Incluir Novo
                                    </a>
                                </div>
                            </div>
                            <div class="card-body">
                                <adm-data-table :headers="headers" :items="Avisos" v-model="itemsSelected" alternating
                                    theme-color="#364f66" table-class-name="customize-table" header-text-direction="center"
                                    body-text-direction="center" rows-per-page-message="Linhas por pagina">
                                    <template #item-admVisivelGarantidora="item">
                                        <span>{{ item.admVisivelGarantidora ? 'Sim' : 'Não' }}</span>
                                    </template>
                                    <template #item-admVisivelImobiliaria="item">
                                        <span>{{ item.admVisivelImobiliaria ? 'Sim' : 'Não' }}</span>
                                    </template>
                                    <template #item-admAtivo="item">
                                        <span>{{ item.admAtivo ? 'Sim' : 'Não' }}</span>
                                    </template>
                                    <template #item-admDtCadastro="item">
                                        <span>{{ formatarData(item.admDtCadastro) }}</span>
                                    </template>
<template #item-actions="item">
    <div class="gp-table-actions">
        <button type="button" class="gp-table-action gp-action-edit" title="Editar" @click="EditGrid(item)"><v-icon size="17">mdi-pencil-outline</v-icon></button>
        <button type="button" class="gp-table-action gp-action-delete" title="Excluir" @click="DeleteGrid(item)"><v-icon size="17">mdi-trash-can-outline</v-icon></button>
    </div>
</template>
                                </adm-data-table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import EasyDataTable from 'vue3-easy-data-table';
export default {
    name: 'CadastroAvisoSistemaView',
    components: {
        EasyDataTable
    },
    data: () => ({
        EditView: false,
        Aviso: {
            admId: 0,
            admTitulo: '',
            admTexto: '',
            admTextoBotao: '',
            admLinkBotao: '',
            admVisivelGarantidora: '',
            admVisivelImobiliaria: '',
            admDataInicial: '',
            admDataFinal: '',
            admAtivo: '',
            admDtCadastro: null,
        },
        Avisos: [],
        headers: [
            { text: "Id", value: "admId", sortable: true, width: 50 },
            { text: "Título", value: "admTitulo", sortable: true, width: 200 },
            { text: "Garantidoras", value: "admVisivelGarantidora", sortable: true, width: 100 },
            { text: "Imobiliárias", value: "admVisivelImobiliaria", sortable: true, width: 100 },
            { text: "Ativo", value: "admAtivo", sortable: true, width: 80 },
            { text: "Data Cadastro", value: "admDtCadastro", sortable: true, width: 120 },
            { text: 'Ações', value: 'actions', width: 100 }
        ],
        itemsSelected: [],
        selectedItem: null,
        searchValue: '',
    }),
    methods: {
        //edit
        EditNew(){
            this.EditView = true;
            this.Aviso.admId = 0;
            this.Aviso.admTitulo = '';
            this.Aviso.admTexto = '';
            this.Aviso.admTextoBotao = '';
            this.Aviso.admLinkBotao = '';
            this.Aviso.admVisivelGarantidora = '';
            this.Aviso.admVisivelImobiliaria = '';
            this.Aviso.admDataInicial = '';
            this.Aviso.admDataFinal = '';
            this.Aviso.admAtivo = '';
        },
        EditGrid(item) {
            this.EditView = true;
            if (item.admId != ''){
                axios.get(`/Telas/CadastroAvisoSistema/GetById/` + item.admId)
                    .then(response => {
                        const data = response.data;
                        data.admDataInicial = this.formatDateForInput(data.admDataInicial);
                        data.admDataFinal = this.formatDateForInput(data.admDataFinal);
                        this.Aviso = data;
                    });
            }
        },
        Add() {
            if (this.Aviso.admTitulo == '') {
                this.$mensagemAviso("Título Obrigatório.")
            }
            else if (this.Aviso.admTexto == '') {
                this.$mensagemAviso("Texto Obrigatório.")
            }
            else if (this.Aviso.admDataInicial === '') {
                this.$mensagemAviso("Data Inicial Obrigatória.")
            }
            else if (this.Aviso.admVisivelGarantidora === '') {
                this.$mensagemAviso("Visível para Garantidoras Obrigatório.")
            }
            else if (this.Aviso.admVisivelImobiliaria === '') {
                this.$mensagemAviso("Visível para Imobiliárias Obrigatório.")
            }
            else if (this.Aviso.admAtivo === '') {
                this.$mensagemAviso("Ativo Obrigatório.")
            }
            else {
                console.log(this.Aviso);
                const payload = { ...this.Aviso };
                // Converter data final vazia em null
                if (payload.admDataFinal === '') {
                    payload.admDataFinal = null;
                }
                // Enviar data de cadastro atual no add
                payload.admDtCadastro = new Date().toISOString();

                axios.post(`/Telas/CadastroAvisoSistema/Add`, payload)
                    .then(response => {
                        if (response.data > 0) {
                            this.$mensagemAvisoSucesso("Registro Incluído.")
                            this.Get();
                        }
                    });
            }
        },
        Put() {
            if (this.Aviso.admTitulo == '') {
                this.$mensagemAviso("Título Obrigatório.")
            }
            else if (this.Aviso.admTexto == '') {
                this.$mensagemAviso("Texto Obrigatório.")
            }
            else if (this.Aviso.admDataInicial === '') {
                this.$mensagemAviso("Data Inicial Obrigatória.")
            }
            else if (this.Aviso.admVisivelGarantidora === '') {
                this.$mensagemAviso("Visível para Garantidoras Obrigatório.")
            }
            else if (this.Aviso.admVisivelImobiliaria === '') {
                this.$mensagemAviso("Visível para Imobiliárias Obrigatório.")
            }
            else if (this.Aviso.admAtivo === '') {
                this.$mensagemAviso("Ativo Obrigatório.")
            }
            else {

                // Converter data final vazia em null
                if (this.Aviso.admDataFinal === '') {
                    this.Aviso.admDataFinal = null
                }
                axios.put(`/Telas/CadastroAvisoSistema/Update`, this.Aviso)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Registro Alterado.")
                            this.Get();
                        }
                    });
            }
        },
        EditCancel(){
            this.$router.go(0);
        },
        DeleteGrid(item) {
            this.$mensagemConfirma('Tem certeza que deseja excluir?')
            .then((result) => {
                if (result.isConfirmed) {
                    const param1 = item.admId;
                    axios.delete(`/Telas/CadastroAvisoSistema/Delete/${param1}`)
                    .then(response => {
                        if (response.status == 200) {
                            this.$mensagemAvisoSucesso("Registro Excluido.")
                            this.Get();
                        }
                    });
                }
            });
        },
        formatarData(data) {
            if (!data) return '';
            const d = new Date(data);
            const dia = String(d.getDate()).padStart(2, '0');
            const mes = String(d.getMonth() + 1).padStart(2, '0');
            const ano = d.getFullYear();
            return `${dia}/${mes}/${ano}`;
        },
        formatDateForInput(value) {
            if (!value) return '';
            const d = new Date(value);
            const year = d.getFullYear();
            const month = String(d.getMonth() + 1).padStart(2, '0');
            const day = String(d.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        async Get() {
            this.EditView = false;
            await axios.get(`/Telas/CadastroAvisoSistema/GetAll`)
               .then(response => {
                this.Avisos = response.data;
           });
        }
    },
    created() {
        this.Get();
    },
}
</script>

<style></style>
